import { atom, selector } from 'recoil';
import { UserTypes, GetDetailUserTypeDtoRx } from '@/sdk/data-contracts';

export const userDivisionListRecoil = atom<UserTypes[]>({
  key: 'userDivisionListRecoil',
  default: [],
});

export const userDivisionModifyRecoil = atom<GetDetailUserTypeDtoRx | null>({
  key: 'userDivisionModifyRecoil',
  default: null,
});

// export const eventDetailRecoil = atom<GetDetailSiteDtoRx | null>({
//   key: 'eventDetailRecoil',
//   default: null,
// });

// export const eventDetailIdRecoil = atom<number | null>({
//   key: 'eventDetailIdRecoil',
//   default: null,
// });
